import { message } from 'antd';
import { LOG_OUT } from '../constants/text.constants';

// Surprisingly, I can't place the logout path or redirect in routes.js directly,
// thus I have to make this into a component function to make it work.
const logOutSequence = () => {
  message.info(LOG_OUT);
  setTimeout(() => {
    // Django handles RP-initiated logout (clears session + Keycloak SSO).
    window.location.href = '/logout/';
  }, 300);
};

export default logOutSequence;
